import { render, staticRenderFns } from "./tmDiagOther.vue?vue&type=template&id=fe4b5fa6&"
import script from "./tmDiagOther.vue?vue&type=script&lang=js&"
export * from "./tmDiagOther.vue?vue&type=script&lang=js&"
import style0 from "./tmDiagOther.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports